module.exports = __webpack_public_path__ + "media/src/images/icons/logo-98099a37dc53c95731ea9c5c410f0b1a.svg";